import type * as React from 'react';
import { get } from '@Domain/Api';
import permissionCatalogFetched, {
	type PermissionCatalogFetchedAction,
	type PermissionCatalogFetchedPayload,
} from '@Application/Security/Roles/Actions/permissionCatalogFetched';
import permissionCatalogFetchFailed, {
	type PermissionCatalogFetchFailedAction,
} from '@Application/Security/Roles/Actions/permissionCatalogFetchFailed';
import type FetchPermissionCatalog from '@Application/Security/Roles/Queries/FetchPermissionCatalog';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = PermissionCatalogFetchedAction | PermissionCatalogFetchFailedAction;

export default (_query: FetchPermissionCatalog) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<PermissionCatalogFetchedPayload>(
				`${parameters.api.host}/api/permissions`,
			);

			const action = permissionCatalogFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = permissionCatalogFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
